module.exports = __webpack_public_path__ + "img/code.8a505359.svg";